import React from "react"
import {Descriptions} from "antd"
import moment from "moment"
import GroupApplyStatus from "../../components/GroupApplyStatus"

const Item = Descriptions.Item

const Info = ({
                item = {}
              }) => {

  const guides = []
  item.pointGuide === 1 && guides.push('定点导览')
  item.lineGuide === 1 && guides.push('标准线路导览')

  return <Descriptions bordered>
    <Item label="团队名称" span={2}>{item.groupName}</Item>
    <Item label="入园日期">
      {moment(item.travelDate).format('Y-MM-DD')}
    </Item>
    <Item label="团队性质" span={2}>
      {item.groupProperty.name}
    </Item>
    <Item label="预计人数">
      {item.peopleCount}
    </Item>
    <Item label="联系人" span={2}>
      {item.contact}
    </Item>
    <Item label="联系人手机">
      {item.mobile}
    </Item>
    <Item label="导览" span={2}>
      {guides.length === 0 ? '不需要' : guides.join('，')}
    </Item>
    <Item label="矿坑预约">
      {item.pitBooking === 1 ? '需要' : '不需要'}
    </Item>
    <Item label="备注" span={3}>
      {item.notes}
    </Item>
    <Item label="附件" span={3}>
      {item.attachmentInfoList && item.attachmentInfoList.map(attachment => <div>
        <a href={attachment.url} target="_blank">{attachment.filename}</a>
      </div>)}
      {item.attachmentInfoList && item.attachmentInfoList.length === 0 && '无'}
    </Item>
    <Item label="状态" span={3}>
      <GroupApplyStatus value={item.status}/>
    </Item>
    <Item label="审核意见" span={3}>
      {item.opinion}
    </Item>
  </Descriptions>
}

export default Info
